import { createFileRoute } from "@tanstack/react-router";
import { useJobTypeDrawerContext } from "@/utils/job-type-detail/job-type-drawer-context";
import { JobTypeActivitySection } from "./fullActivity";

export const Route = createFileRoute(
	"/_authenticated/(admin-app)/_admin/admin/configuration/jobTypes/$jobTypeId/activity",
)({
	component: AdminJobTypeActivityTab,
});

function AdminJobTypeActivityTab() {
	const { jobType } = useJobTypeDrawerContext();

	return (
		<div className="p-4">
			<JobTypeActivitySection jobType={jobType} />
		</div>
	);
}
